import { createAsyncThunk } from '@reduxjs/toolkit';
import httpService from './httpService';

export const checkItemNumber: any = createAsyncThunk<any>(
	'checkItemNumber',
	async (data: any) => {
		const response = await httpService.get(
			`/productService/product/existItemNumber`,
			{ params: data }
		);
		return response.data.data;
	}
);
export const checkBarcode: any = createAsyncThunk<any>(
	'checkBarcode',
	async (data: any) => {
		const response = await httpService.get(
			`/productService/product/existTenantBarcode`,
			{ params: data }
		);
		return response.data.data;
	}
);

export const addProduct: any = createAsyncThunk<any>(
	'addProduct',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/productService/product',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getProductList: any = createAsyncThunk<any>(
	'getProductList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/product/products',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const updataeProductStatus: any = createAsyncThunk<any>(
	'updataeProductStatus',
	async (data: any, { rejectWithValue }) => {
		try {
			console.log('here; in the updatae', data);
			const response = await httpService.put(
				'/productService/product/products',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const GetProductDetails: any = createAsyncThunk<any>(
	'GetProductDetails',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get('/productService/product', {
				params: data
			});
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const editProductDetails: any = createAsyncThunk<any>(
	'editProductDetails',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put(
				'/productService/product',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const getInventoryProductList: any = createAsyncThunk<any>(
	'getInventoryProductList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.get(
				'/productService/product/inventoryProductList',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const swapProductImages: any = createAsyncThunk<any>(
	'swapProductImages',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post(
				'/productService/imageUpload/swapProductImages',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const deleteProductList: any = createAsyncThunk<any>(
	'deleteProductList',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.delete(
				'/productService/product',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const updataeVariantAndGroup: any = createAsyncThunk<any>(
	'updataeVariantAndGroup',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put(
				'/productService/product/update-variant-group',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);

export const deleteProductVariant: any = createAsyncThunk<any>(
	'deleteProductVariant',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.delete(
				'/productService/product/productVariant',
				{
					params: data
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const swapVariants: any = createAsyncThunk<any>(
	'swapVariants',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put(
				'/productService/product/changeVariantOrder',
				data
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
